import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

function ArticleCard({ article, index }: { article: Article; index: number }) {
  return (
    <article className="animate-fadeInUp" style={{ animationDelay: `${index * 0.05}s`, opacity: 0 }}>
      <Link
        to={`/article/${article.id}`}
        className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
      >
        <div className="sm:w-52 flex-shrink-0 h-36 sm:h-32 overflow-hidden rounded-md">
          <img
            src={article.coverImage}
            alt={article.title}
            title={`${article.title} - 爆料网`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        <div className="flex flex-col flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1.5 flex-wrap">
            <span className="px-2 py-0.5 bg-secondary-100 text-secondary-900 text-xs font-label rounded whitespace-nowrap">
              {article.categoryName}
            </span>
            {article.isHot && (
              <span className="flex items-center gap-0.5 text-accent-500 text-xs font-label whitespace-nowrap">
                <i className="ri-fire-fill"></i> 热门
              </span>
            )}
          </div>
          <h3 className="font-label text-base font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2 flex-1">
            {article.excerpt}
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400 font-label">
            <span className="whitespace-nowrap">{article.author}</span>
            <span className="whitespace-nowrap">{new Date(article.publishedAt).toLocaleDateString('zh-CN')}</span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-eye-line"></i> {(article.views / 10000).toFixed(0)}万
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-chat-3-line"></i> {article.comments}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}

interface LatestSectionProps {
  articles: Article[];
}

export default function LatestSection({ articles }: LatestSectionProps) {
  return (
    <section className="py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            最新爆料
          </h2>
        </div>
        <div className="flex flex-col gap-4" data-product-shop="">
          {articles.length > 0 ? (
            articles.map((article, index) => (
              <ArticleCard key={article.id} article={article} index={index} />
            ))
          ) : (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-5xl text-foreground-300"></i>
              <p className="mt-4 text-foreground-500">暂无相关爆料内容</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}